const MS_PER_DAY = 86400000;

// Calendar days since 1970-01-01 for a YYYYMMDD number, so day arithmetic is plain subtraction
export const utcToDayNum = (utcDate) => {
  const text = String(utcDate);
  return Math.round(
    Date.UTC(
      Number(text.slice(0, 4)),
      Number(text.slice(4, 6)) - 1,
      Number(text.slice(6, 8))
    ) / MS_PER_DAY
  );
};

/**
 * Converts a day number to a UTC date.
 * @param {*} day
 * @returns
 */
export const dayNumToUtc = (day) => {
  const date = new Date(day * MS_PER_DAY);
  return (
    date.getUTCFullYear() * 10000 +
    (date.getUTCMonth() + 1) * 100 +
    date.getUTCDate()
  );
};
